import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.define-property";

var _this2 = this;

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import { Events } from "./Events";

var ResizeEvents =
/*#__PURE__*/
function () {
  function ResizeEvents() {
    _classCallCheck(this, ResizeEvents);
  }

  _createClass(ResizeEvents, null, [{
    key: "runCallbacks",
    value: function runCallbacks() {
      var _this = this;

      if (!ResizeEvents.enabled) {
        return;
      }

      ResizeEvents.events.setRunning();
      var newViewport = typeof document !== "undefined" && document.body && window.getComputedStyle(document.body, ":after").content.replace(/["']/g, "");

      if (ResizeEvents.viewport !== newViewport) {
        ResizeEvents.viewport = newViewport;
        ResizeEvents.viewportCallbacks.forEach(function (callback) {
          _newArrowCheck(this, _this);

          callback(ResizeEvents.getViewportSize());
        }.bind(this));
      }

      var ratio = typeof window !== "undefined" && window.innerWidth / window.innerHeight;
      ResizeEvents.resizeCallbacks.forEach(function (callback) {
        _newArrowCheck(this, _this);

        callback();
      }.bind(this));
      ResizeEvents.ratioCallbacks.forEach(function (callbackObject) {
        _newArrowCheck(this, _this);

        var minRatio = callbackObject.minRatio,
            lastResult = callbackObject.lastResult,
            callback = callbackObject.callback;
        var currentResult = ratio >= minRatio;

        if (currentResult !== lastResult) {
          callback(currentResult);
          callbackObject.lastResult = currentResult;
        }
      }.bind(this));
    }
  }]);

  return ResizeEvents;
}(); // tslint:disable member-ordering


ResizeEvents.events = new Events("resize", ResizeEvents.runCallbacks);
ResizeEvents.resizeCallbacks = [];
ResizeEvents.ratioCallbacks = [];
ResizeEvents.viewportCallbacks = [];
ResizeEvents.viewport = "none";
/*
  typeof document !== 'undefined' &&
  document.body &&
  window.getComputedStyle(document.body, ':after').content.replace(/["']/g, '');#*/

ResizeEvents.addResizeCallback = function (callback) {
  _newArrowCheck(this, _this2);

  ResizeEvents.resizeCallbacks.push(callback);
  ResizeEvents.runCallbacks();
}.bind(this);

ResizeEvents.enable = function () {
  _newArrowCheck(this, _this2);

  if (!ResizeEvents.enabled) {
    ResizeEvents.enabled = true;
    ResizeEvents.runCallbacks();
  }
}.bind(this);

ResizeEvents.addRatioCallback = function (minRatio, callback) {
  _newArrowCheck(this, _this2);

  ResizeEvents.ratioCallbacks.push({
    callback: callback,
    lastResult: undefined,
    minRatio: minRatio
  });
  ResizeEvents.runCallbacks();
}.bind(this);

ResizeEvents.addViewportCallback = function (callback) {
  _newArrowCheck(this, _this2);

  ResizeEvents.viewportCallbacks.push(callback);
  ResizeEvents.runCallbacks();
}.bind(this);

ResizeEvents.removeResizeCallback = function (callback) {
  var _this3 = this;

  _newArrowCheck(this, _this2);

  return ResizeEvents.resizeCallbacks = ResizeEvents.resizeCallbacks.filter(function (c) {
    _newArrowCheck(this, _this3);

    return c !== callback;
  }.bind(this));
}.bind(this);

ResizeEvents.removeRatioCallback = function (callback) {
  var _this4 = this;

  _newArrowCheck(this, _this2);

  return ResizeEvents.ratioCallbacks = ResizeEvents.ratioCallbacks.filter(function (o) {
    _newArrowCheck(this, _this4);

    return o.callback !== callback;
  }.bind(this));
}.bind(this);

ResizeEvents.removeViewportCallback = function (callback) {
  var _this5 = this;

  _newArrowCheck(this, _this2);

  return ResizeEvents.viewportCallbacks = ResizeEvents.viewportCallbacks.filter(function (c) {
    _newArrowCheck(this, _this5);

    return c !== callback;
  }.bind(this));
}.bind(this);

ResizeEvents.getViewportSize = function () {
  _newArrowCheck(this, _this2);

  return ResizeEvents.viewport;
}.bind(this);

export { ResizeEvents };